import gql from 'graphql-tag'

export const GET_DASHBOARD_SUMMARY = gql`
  query getDashboardSummary {
    dashboardSummary {
      scope
      awaiting_my_approval
      oversight {
        pending_count
        is_single_department
        branch_breakdown {
          branch
          count
        }
        department_expense_breakdown {
          department
          amount
        }
        state_mix {
          state
          count
        }
        processed_amount
        processed_count
        monthly_volume {
          month
          count
          total_amount
        }
        has_budget_access
        budget_scope
        cost_category_budgets {
          category
          spent
          budgeted
        }
      }
      personal {
        in_progress_count
        drafts_count
        paid_count
        paid_amount
        recent_vouchers {
          id
          reference_number
          state
          total_amount
          expense_period
          created_at
        }
        monthly_volume {
          month
          count
          total_amount
        }
      }
    }
  }
`
